export type ProductItemDialogPagesType = {
  PRODUCT_TEMPLATE: number;
  ITEM_DETAILS: number;
  ITEM_RELEASE: number;
  STOCK_MANAGEMENT: number;
  ITEM_PRICING: number;
  ITEM_PRICING_UNBUNDLED: number;
  ITEM_VISIBILITY: number;
  ITEM_DELIVERY_METHOD_RULES: number;
  NO_BASE_LIST: number;
};

export const ProductItemDialogPages: ProductItemDialogPagesType = {
  PRODUCT_TEMPLATE: 0,
  ITEM_DETAILS: 1,
  ITEM_RELEASE: 2,
  STOCK_MANAGEMENT: 3,
  ITEM_PRICING: 4,
  ITEM_PRICING_UNBUNDLED: 5,
  ITEM_VISIBILITY: 6,
  ITEM_DELIVERY_METHOD_RULES: 7,
  NO_BASE_LIST: 8,
};
